import { useEffect } from 'react'

export function SaveOnPress ({
  saveRef,
  onKeyPress,
  editable = true,
  children,
  onKeyDown,
  focus = true
}) {
  useEffect(() => {
    if (focus) {
      saveRef?.current?.focus()
    }
  }, [ focus, editable, saveRef ])

  if (!editable) {
    return children
  }

  return (
    <button
      onKeyDown={onKeyDown}
      onKeyPress={onKeyPress}
      ref={saveRef}
      className='saveOnPress'
    >
      {children}
    </button>
  )
}
